import { render } from "./strap-line.component.vue?vue&type=template&id=38c0a128&ts=true"
import script from "./strap-line.component.ts?vue&type=script&lang=ts"
export * from "./strap-line.component.ts?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__